<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <span class="mr-auto">
    <button mat-raised-button routerLink="/toolbox-talks-templates" class="m-1 mr-2">
      <mat-icon>arrow_back</mat-icon> {{ utils.getLangTerm('toolbox-talks.plural', 'Toolbox Talks') }} Templates
    </button>

    <button mat-raised-button (click)="onEdit(toolbox_talk.id)" *ngIf="canEdit" class="m-1 mr-2">
      <mat-icon>edit toolbox_talk.id</mat-icon> Edit
    </button>
    <button mat-raised-button (click)="onRemove()" *ngIf="canDelete" class="m-1 mr-2" color="warn">
      <mat-icon>delete</mat-icon> Delete
    </button>

    <button mat-raised-button (click)="onExport('pdf')" *ngIf="canView" color="secondary" class="m-1 mr-2">
      <mat-icon>cloud_download</mat-icon> Export PDF
    </button>

    <button mat-raised-button (click)="onExport('csv')" *ngIf="canView" color="secondary" class="m-1 mr-2">
      <mat-icon>cloud_download</mat-icon> Export CSV
    </button>
  </span>
</nav>

<mat-tab-group *ngIf="urlPath == 'view'">
  <mat-tab label="Overview">
    <app-toolbox-talks-templates-view [ToolboxTalksTemplatesTabsComponent]="this"></app-toolbox-talks-templates-view>
  </mat-tab>
</mat-tab-group>
